import "./Hero.css"

const Hero = () => {
  return (
    <div className="hero">
      <h1>Hand-made accessories</h1>
      <button className="hero-button"><a className="hero-button-text" href="https://www.instagram.com/alia_storee/" target="_blank">Products</a></button>
    </div>
  )
}

export default Hero;